var map = {
	"./wizard-loader-1.png": "6915",
	"./wizard-loader-2.png": "9549",
	"./wizard-loader-3.png": "bcd4",
	"./wizard-loader-4.png": "3805",
	"./wizard-loader-5.png": "f13e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7d10";